import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { FormSubmitFunction } from "lib/form";
import { ListUser } from "models/list-user";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { LeftButtons, RightButtons } from "./form.styles";

interface ListSummaryFormProps {
  listUser: ListUser;
  onSubmit: FormSubmitFunction;
  onFirst: () => Promise<void>;
  onPrevious: () => Promise<void>;
}

const ListSummaryForm: FunctionComponent<ListSummaryFormProps> = ({
  listUser,
  onSubmit,
  onFirst,
  onPrevious,
}) => {
  const methods = useForm({
    resolver: yupResolver(yup.object()),
    defaultValues: {},
  });

  const navButtons: FormButtonInterface[] = [
    {
      ...CancelButton,
      text: "Siirry alkuun",
      onClick: onFirst,
      align: "left",
    },
    {
      ...CancelButton,
      text: "Edelliseen",
      onClick: onPrevious,
      align: "left",
    },
  ];

  const secondButtons: FormButtonInterface[] = [];
  const submitDisabled =
    listUser.status === "submitted" || listUser.status === "approved";
  secondButtons.push({
    ...SubmitButton,
    text: "Lähetä tarkastettavaksi",
    align: "right",
    disabled: submitDisabled,
  });

  return (
    <Form onSubmit={onSubmit} methods={methods}>
      <Grid>
        <Row>
          <LeftButtons>
            <FormButtons buttons={navButtons} />
          </LeftButtons>
          <RightButtons>
            <FormButtons buttons={secondButtons} />
          </RightButtons>
        </Row>
      </Grid>
    </Form>
  );
};

export default ListSummaryForm;
